// REACT
import { useState } from "react";

// API TYPES
import { IUserReview, TSelectionItem } from "../interfaces";

// Images
import emptyTable from "@/assets/images/commons/empty_table.png";

// Components
import EmptyBody from "@/Layouts/components/Basics/EmptyBody";
import TitlePositionSelector from "./TitlePositionSelector";
import SocialMediaReviewAssociateTable from "./SocialMediaReviewAssociateTable";
import { SocialMediaReviewDetailedDialogProvider } from "@DataPages/context/customerRelations/SocialMediaReviewDetailedDialogContext";

type TSocialMediaReviewPositionProps = Readonly<{
	locationId: string;
	selectedItem: TSelectionItem | null;
	positionsContent: IUserReview[];
	isDataPresent: boolean;
	isUpdatable: boolean;
	isLoading: boolean;
	options: string[];
	onDemand: boolean | undefined;
}>;

export default function SocialMediaReviewAssociatesSection(props: TSocialMediaReviewPositionProps) {
	const { options, positionsContent, isDataPresent, onDemand, locationId, isLoading, selectedItem } = props;

	// States
	const [indexTab, setIndexTab] = useState(0);

	/*********************************************** HANDLERS ************************************************/
	const handleTabOnChange = (index: number) => {
		setIndexTab(index);
	};

	if (!isDataPresent && !isLoading) {
		return (
			<EmptyBody
				image={emptyTable}
				title={`No Social Media Reviews found`}
				bodyHeight={"435px"}
				className="!shadow-none !h-[460px]"
			/>
		);
	}

	return (
		<SocialMediaReviewDetailedDialogProvider>
			<TitlePositionSelector isLoading={isLoading} activeOption={indexTab} positions={options} onChangePosition={handleTabOnChange} />

			<SocialMediaReviewAssociateTable
				isLoading={isLoading}
				options={options}
				indexTab={indexTab}
				positionsContent={positionsContent}
				isDataPresent={isDataPresent}
				selectedItem={selectedItem}
				locationId={locationId}
				onDemand={onDemand}
			/>
		</SocialMediaReviewDetailedDialogProvider>
	);
}
